import './index.scss'
import LogoS from '../../assets/images/logo-u.png'
import LogoSubtitle from '../../assets/images/logo_subu.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faLinkedin,
  faGithub,
  faYoutube,
  faDiscord,
} from '@fortawesome/free-brands-svg-icons'
import { faHome, faUser, faEnvelope, faSuitcase, faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import { Link, NavLink } from 'react-router-dom'
import React, { useState } from 'react'

const Sidebar = ({ isMobileMenuOpen, toggleMobileMenu, closeMobileMenu }) => {
  const [copied, setCopied] = useState(false);

  const handleDiscordClick = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText('Uzi9');
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleNavClick = () => {
    // Close mobile menu when a nav item is clicked
    if (closeMobileMenu) {
      closeMobileMenu();
    }
  };

  return (
    <>
      {/* Mobile hamburger button */}
      <button 
        className="mobile-menu-btn"
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
      </button>

      {/* Mobile overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}></div>
      )}

      <div className={`nav-bar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        <Link className="logo" to="/" onClick={handleNavClick}>
          <img src={LogoS} alt="Logo" />
          <img className="sub-logo" src={LogoSubtitle} alt="Uzair" />
        </Link>
        <nav>
          <NavLink exact="true" activeclassname="active" to="/" onClick={handleNavClick}>
            <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
          </NavLink>
          <NavLink activeclassname="active" className="about-link" to="/about" onClick={handleNavClick}>
            <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
          </NavLink>
          <NavLink activeclassname="active" className="portfolio-link" to="/portfolio" onClick={handleNavClick}>
            <FontAwesomeIcon icon={faSuitcase} color="#4d4d4e" />
          </NavLink>
          <NavLink
            activeclassname="active"
            className="contact-link"
            to="/contact"
            onClick={handleNavClick}
          >
            <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
          </NavLink>
        </nav>
        <ul>
          <li>
            <a
              href="https://www.linkedin.com/in/uzair-kamran-76a174266/"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedin} color="#4d4d4e" />
            </a>
          </li>
          <li>
            <a
              href="https://github.com/uzii9"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/@u.k842"
              rel="noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon icon={faYoutube} color="#4d4d4e" />
            </a>
          </li>
          <li>
            <button
              type="button"
              onClick={handleDiscordClick}
              className="icon-button"
              aria-label="Copy Discord username"
              style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faDiscord} color="#4d4d4e" />
            </button>
          </li>
        </ul>
        {copied && (
          <div className="copy-notification">Discord name 'Uzi9' copied!</div>
        )}
      </div>
    </>
  )
}

export default Sidebar